import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, Output } from '@angular/core';
import { BaseModalComponent } from '../../../core/layout/components/abstracts/base-modal.component';
import { ModalComponent } from '../modal/modal.component';
import { Subscription, take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [
    ModalComponent,
  ],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationModalComponent extends BaseModalComponent<unknown> {

  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  public static instance: ConfirmationModalComponent;
  public text: string;
  public confirmButtonText = 'Yes'.trans('confirmation-modal/buttons.Yes');
  public cancelButtonText = 'No'.trans('confirmation-modal/buttons.No');

  private _isConfirmed = false;
  private _confirmSub: Subscription;

  public constructor() {
    super();

    ConfirmationModalComponent.instance = this;
  }

  public confirm(): void {
    this._isConfirmed = true;
    this.onConfirm.emit();
    this.close();
  }

  public cancel(): void {
    ConfirmationModalComponent.instance._confirmSub?.unsubscribe();

    if (!this._isConfirmed) {
      this.onCancel.emit();
    }

    this._isConfirmed = false;
  }

  public override close(): void {
    super.close();
    this.onConfirm = new EventEmitter<void>();
    this.onCancel = new EventEmitter<void>();
  }

  public static openConfirmationModal(
    title: string,
    text: string,
    destroyRef: DestroyRef,
    onConfirmCb?: () => void
  ): void {
    ConfirmationModalComponent.instance.title = title;
    ConfirmationModalComponent.instance.text = text;

    ConfirmationModalComponent.instance._confirmSub?.unsubscribe();

    ConfirmationModalComponent.instance._confirmSub = ConfirmationModalComponent.instance.onConfirm
      .pipe(
        take(1),
        takeUntilDestroyed(destroyRef)
      )
      .subscribe(() => {
        if (onConfirmCb) {
          onConfirmCb();
        }
      });

    ConfirmationModalComponent.instance.open();
  }
}
